import GetVaccinationCertificate from './GetVaccinationCertificate'

export default GetVaccinationCertificate
